import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { CommonResult } from '../../../external/Common';
import { MailTemplateItem } from '../../../external/MailTemplateDetailApi';
import { actions } from '../../modules/Actions';

export interface MailTemplateDetailState {
  mailTemplate: MailTemplateItem | null;
  result: CommonResult | null;
}

export const initialState: MailTemplateDetailState = {
  mailTemplate: null,
  result: null
};

export const MailTemplateDetailReducer = reducerWithInitialState(initialState)
  .case(
    actions.fetchMailTemplateDetail, (state: MailTemplateDetailState, payload: MailTemplateDetailState) => {
      return payload;
    }
  );

